import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { HttpOptionsFactory, UrlCollection } from '@dot-it/jml-lib'
import { Observable } from 'rxjs'
import { AdditionalQualifier } from '../models/table-state.model'

@Injectable({
  providedIn: 'root'
})
export class SelectionService {
  private http = inject(HttpClient)

  selectAll(
    type: string,
    mainId: number,
    ownerId: number,
    ownerType: string,
    qualifier: string,
    additionalQualifier: AdditionalQualifier
  ) {
    return this.http.post(
      UrlCollection.Entities.SELECT_ALL(),
      { type, mainId, ownerType, ownerId, qualifier, additionalQualifier },
      new HttpOptionsFactory().addAcceptJson().addContentTypeJson().build()
    )
  }

  unselectAll(
    type: string,
    mainId: number,
    ownerId: number,
    ownerType: string,
    qualifier: string,
    additionalQualifier: AdditionalQualifier
  ) {
    return this.http.post(
      UrlCollection.Entities.UNSELECT_ALL(),
      { type, mainId, ownerType, ownerId, qualifier, additionalQualifier },
      new HttpOptionsFactory().addAcceptJson().addContentTypeJson().build()
    )
  }

  select(type: string, ids: number[]): Observable<any> {
    return this.http.post(
      UrlCollection.Entities.SELECT(),
      { type, ids },
      new HttpOptionsFactory().addAcceptJson().addContentTypeJson().build()
    )
  }

  unselect(type: string, ids: number[]): Observable<any> {
    return this.http.post(
      UrlCollection.Entities.UNSELECT(),
      { type, ids },
      new HttpOptionsFactory().addAcceptJson().addContentTypeJson().build()
    )
  }

  getSelectedCount(type: string): Observable<number> {
    return this.http.get<number>(
      UrlCollection.Entities.GET_SELECTED_COUNT(type),
      new HttpOptionsFactory().addAcceptJson().addContentTypeJson().build()
    )
  }
}
